export enum InputType {
    BOOLEAN = 'Boolean',
    STRING = 'String',
    OPTION = 'Option',
    UNIT = 'Unit'
}